import { eyeshadowColors } from './cheekEyeshadowColors';

const eyeshadowConfig = {
  id: 'eyeshadow',
  label: 'Eyeshadow',
  icon: 'eyeshadow',
  colors: eyeshadowColors,
  finishTypes: [
    { id: 'matte', name: 'Matte' },
    { id: 'satin', name: 'Satin' },
    { id: 'shimmer', name: 'Shimmer' },
    { id: 'glossy', name: 'Glossy' },
    { id: 'metallic', name: 'Metallic' },
  ],
  intensityDefault: 65,
  intensityMin: 0,
  intensityMax: 100,
};

export default eyeshadowConfig;
